/**
 * Retry Configuration
 * Defines retry strategies for different types of errors
 */

export interface UseSmartRetryConfig {
  maxAttempts: number;
  initialDelay: number;
  maxDelay: number;
  backoffMultiplier: number;
  resetOnSuccess: boolean;
}

export interface RetryConfig {
  network: UseSmartRetryConfig;    // For network/connection errors
  service: UseSmartRetryConfig;    // For backend service errors
  config: UseSmartRetryConfig;     // For configuration loading errors
}

export const getRetryConfig = (): RetryConfig => {
  const maxAttempts = parseInt(process.env.REACT_APP_RETRY_MAX_ATTEMPTS || '5');
  const initialDelay = parseInt(process.env.REACT_APP_RETRY_INITIAL_DELAY || '1000');
  const maxDelay = parseInt(process.env.REACT_APP_RETRY_MAX_DELAY || '30000');
  const backoffMultiplier = parseFloat(process.env.REACT_APP_RETRY_BACKOFF_MULTIPLIER || '2');

  return {
    network: {
      maxAttempts,
      initialDelay,
      maxDelay,
      backoffMultiplier,
      resetOnSuccess: true,
    },
    service: {
      maxAttempts: Math.max(1, maxAttempts - 2), // Fewer retries for service errors
      initialDelay: initialDelay * 2, // Longer initial delay
      maxDelay,
      backoffMultiplier,
      resetOnSuccess: true,
    },
    config: {
      maxAttempts: 3, // Limited retries for config
      initialDelay,
      maxDelay: 10000, // Shorter max delay
      backoffMultiplier,
      resetOnSuccess: true,
    },
  };
};

export const DEFAULT_RETRY_CONFIG = getRetryConfig();
